import { ProviderTiny } from "@/types/provider";

import { formatStaffName } from "./format-data";

export const getProviderNames = (
  providers: ProviderTiny[],
  delimiter = ", ",
) => {
  return providers.map((provider) => formatStaffName(provider)).join(delimiter);
};
